import React from 'react';

const TabletAndMobileContainer = props => {
  return <div className="br-sm" {...props} />;
};

export default TabletAndMobileContainer;
